module.exports = __webpack_public_path__ + "static/logo-c6abf56ce46c26f5d2c1eeef30e6b3a4.svg";